<!-- [コンテンツ領域] -->
<div class="l-core-contents__inner l-core-contents__inner--full">
  <div class="l-core-contents__main">
    <div *ngIf="!isSp" class="l-section">
      <div class="p-result-function">
        <div class="p-result-function__block">
          <div class="p-result-function__item">
            <button
              id="find-more-flights-pres-pc-filter-btn"
              (throttleClick$)="openFilterConditionModal()"
              class="p-result-function__btn p-result-function__btn--filter"
              aswThrottleClick
            >
              <span class="p-result-function__btn-text" [innerHTML]="'label.filter' | staticMsg"></span>
            </button>
          </div>
          <div class="p-result-function__item">
            <button
              id="find-more-flights-pres-pc-sort-btn"
              (throttleClick$)="openSortConditionModal()"
              class="p-result-function__btn p-result-function__btn--sort"
              aswThrottleClick
            >
              <span class="p-result-function__btn-text" [innerHTML]="sortDataForDisplay | staticMsg"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="l-section u-mt-pc-24">
      <div class="p-flight-bound">
        <div class="p-flight-bound__heading">
          <div class="p-flight-bound__heading-title">
            <h2
              class="c-bound-title01"
              [innerHTML]="'label.number.section.n' | staticMsg : { '0': moreFlightsBoundReference }"
            ></h2>
          </div>
        </div>
        <div class="p-flight-bound__bound">
          <span class="p-flight-bound__fromto">
            <span class="p-flight-bound__fromto-from">{{ this.departure }}</span>
            <span class="p-flight-bound__fromto-separator" [innerHTML]="'label.section' | staticMsg"></span>
            <span class="p-flight-bound__fromto-to">{{ this.arrival }}</span>
          </span>
        </div>
        <ng-container *ngIf="this.transit">
          <div
            class="p-flight-bound__via"
            [innerHTML]="'label.oneStopFlightLocation' | staticMsg : { '0': this.transit }"
          ></div>
        </ng-container>
        <div
          class="p-flight-bound__bound03"
          [innerHTML]="this.boundDepartureDate ?? '' | dateFormat : 'default_departuredate'"
        ></div>
      </div>
    </div>
    <ng-container *ngIf="showPromotionIcon">
      <div class="l-section u-mt-pc-40 u-mt-tb-32 u-mt-sp-16">
        <span class="c-promotion-applied" aria-hidden="true">
          <img
            class="c-promotion-applied__img"
            src="assets/images/icon_promotion_applied_20.svg"
            width="20"
            height="20"
            alt=""
          />
          <span class="c-promotion-applied__text" [innerHTML]="'label.promotionApplied' | staticMsg"></span>
        </span>
      </div>
    </ng-container>
    <ng-container *ngFor="let airOffer of airOffersList; index as airOfferIndex">
      <asw-fmf-search-result
        id="ts{{ airOfferIndex }}"
        *ngIf="airOffer.bounds?.[this.currentBoundIndex]?.flights"
        [currentBoundIndex]="this.currentBoundIndex"
        [isSelectedOffer]="airOffer.isSelectedOffer"
        [isUnavailable]="airOffer.isUnselectable"
        [reasonForUnselectable]="airOffer.reasonForUnselectable"
        [bound]="airOffer.bounds?.[this.currentBoundIndex]"
        [complexBounds]="airOffer.complexBounds"
        [isPromotionApplied]="airOffer.prices?.totalPrice?.discount !== undefined"
        [priceDifference]="airOffer.prices?.previousSelectionPriceDifference?.priceDifference?.value"
        [aircraftConfigurationVersions]="airOffer.complexBounds?.[this.currentBoundIndex]?.aircraftConfigurationVersions"
        [airOfferId]="this.airOffer.id"
        [boundDepartureAirportCode]="this.boundDepartureAirportCode"
        [boundArrivalAirportCode]="this.boundArrivalAirportCode"
        (airOfferSelectEvent)="this.airOfferSelect(airOffer)"
      ></asw-fmf-search-result>
    </ng-container>
    <div>
      <div class="p-date-display01">
        <div
          class="p-date-display01__time"
          [innerHTML]="searchDateTimeString | dateFormat : 'default_currentDate'"
        ></div>
      </div>
    </div>
  </div>
</div>
<!-- [コンテンツ領域] -->

<!-- [画面下部固定フローティングナビ] -->
<div *ngIf="isSp" class="l-bottom-float">
  <!-- [下部固定エリア内機能ボタンエリア] -->
  <div class="p-bottom-float-function-icon">
    <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--left01">
      <button
        id="find-more-flights-pres-sp-filter-btn"
        (throttleClick$)="openFilterConditionModal()"
        class="p-bottom-float-function-icon__btn"
        title="{{ 'alt.searchConditionsFilter' | staticMsg }}"
        aswThrottleClick
      >
        <img
          src="assets/images/icon_filter_primary_20.svg"
          width="20"
          height="20"
          alt="{{ 'alt.searchConditionsFilter' | staticMsg }}"
          aria-hidden="true"
        />
      </button>
    </div>
    <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--left02">
      <button
        id="find-more-flights-pres-sp-sort-btn"
        (throttleClick$)="openSortConditionModal()"
        class="p-bottom-float-function-icon__btn"
        title="{{ 'alt.searchConditionsSort' | staticMsg }}"
        aswThrottleClick
      >
        <img
          src="assets/images/icon_sort_primary_20.svg"
          width="20"
          height="20"
          alt="{{ 'alt.searchConditionsSort' | staticMsg }}"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
  <!-- //[下部固定エリア内機能ボタンエリア] -->
</div>
